import { NgModule } from "@angular/core";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { ModalComponentsModule } from "./common/utils/modals";
import { AdBlockDetectorModule, provideRestHttpConfig } from "./core";
import { LanternAnalyticsModule } from "./core/analytics";
import { pages } from "./pages";

import { LanternAppRoutingModule } from "./lantern-app-routing.module";
import { LanternAppComponent } from "./lantern-app.component";

@NgModule({
  imports: [
    AdBlockDetectorModule,
    BrowserModule,
    BrowserAnimationsModule,
    LanternAppRoutingModule,
    ModalComponentsModule,
    LanternAnalyticsModule,
    MatProgressBarModule,
    ...pages,
  ],
  declarations: [LanternAppComponent],
  providers: [
    provideRestHttpConfig({
      baseUrl: "/api"
    })
  ],
  exports: [LanternAppComponent]
})
export class LanternAppModule {}
